/*
 * @Author: Dom
 * @Date: 2022-05-18 14:36:47
 * @LastEditTime: 2022-07-29 16:47:58
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\personal\authent\locales\en-US.ts
 */
export default{
    'page.personal.center.account': 'Account authentication',
    'page.personal.center.customer': 'Customer information',
    'page.personal.center.registered': 'Registered account',
    'page.personal.center.notcertified': 'Not certified',
    'page.personal.center.certifing': 'Under certification',
    'page.personal.center.certified': 'Certified',
    'page.personal.center.certifiedfail': 'Authentication failed',
    'page.personal.center.authstatus': 'Authentication status',
    'page.personal.center.customernumber': 'Customer number',
    'page.personal.center.password': 'Password',
    'page.personal.center.modify': 'Modify',
    'page.personal.center.customertype': 'Customer type',
    'page.personal.center.person': 'Personal',
    'page.personal.center.enterprise': 'Enterprise',
    'page.personal.center.contractstatus': 'Contract status',
    'page.personal.center.notsigned': 'Not signed',
    'page.personal.center.clicksign': 'Click sign',
    'page.personal.center.signed': 'Signed',
    'page.personal.center.signeing': 'Signing',
    'page.personal.center.phonebind': 'Mobile phone binding number',
    'page.personal.center.clickbind': 'Click bind',
    'page.personal.center.clickchange': 'Click Modify',
    'page.personal.center.title.changepassword': 'Change Password',
    'page.personal.center.title.bindphone': 'Mobile phone binding number',
    'page.personal.center.title.changephone': 'Modify mobile phone number',
    'page.personal.center.title.modify': 'Modify',
}
